<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import thrpyApi from '@/services/api/thrpy.api'
import LocationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Ofrecimiento de Servicios Relacionados por estudiantes',
      routes: [
        'Informes',
        'Ofrecimiento de Servicios Relacionados por estudiantes',
      ],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          months: [],
          providers: [],
          specialists: [],
          centers: [],
        },
        filters: {
          academicYear: null,
          error: null,
          month: null,
          provider: null,
          specialist: null,
          center: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          class: 'col-md-2',
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un mes.',
          validations: 'required',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
          class: 'col-md-2',
          disabled: this.model.search.collections.months.length <= 0,
          onChanged: this.onChangeMonth,
        },

        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un proveedor.',
          validations: 'required',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-6',
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
          onChanged: this.onChangeProvider,
        },

        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          class: 'col-md-2',
          disabled: this.model.search.collections.centers.length <= 0,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-4',
          disabled:
            this.model.search.collections.specialists.length <= 0 ||
            this.model.search.collections.specialists.length == 1,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async onChangeAcademicYear() {
      this.model.search.filters.month = null
      this.model.search.filters.provider = null
      this.model.search.collections.providers = []
      this.model.search.filters.center = null

      await this.getMonth()
      await this.getCenters()
    },
    async onChangeMonth() {
      this.model.search.filters.provider = null
      if (this.model.search.filters.month) {
        await this.getProvider()
      }
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null
      await this.getSpecialist()
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
    },
    async onHandlerSearch() {
      await this.process()
    },
    async process() {
      if (this.hasValue(this.model.search.filters.academicYear?.id)) {
        await ReportServices.getReport('registeredVisits', {
          FiscalYearId: this.model.search.filters.academicYear?.id,
          MonthNumber: this.model.search.filters.month?.id,
          CompanyId: this.model.search.filters.provider?.id,
          BillingCenterId: this.model.search.filters.center?.id,
          AdmissionSpecialistId: this.model.search.filters.specialist?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
    async getMonth() {
      await thrpyApi
        .getTherapyMonth({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          this.model.search.collections.months = res.data
        })
    },
    async getProvider() {
      await providerApi
        .getProviderCompanies({
          academicYearId: this.model.search.filters.academicYear?.id,
          month: this.model.search.filters.month?.name,
        })
        .then((res) => {
          this.model.search.collections.providers = res.data

          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
            this.getSpecialist()
          }
        })
    },
    async getSpecialist() {
      await thrpyApi
        .getTherapyEspecialist({
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
        })
        .then((res) => {
          this.model.search.collections.specialists = res.data

          if (res.data.length == 1) {
            this.model.search.filters.specialist = res.data[0]
          }
        })
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear?.id,
      }).then((res) => (this.model.search.collections.centers = res.data))
    },
    hasValue(paramValue) {
      return paramValue !== null && paramValue !== undefined
    },
  },
}
</script>
